/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import * as tslib_1 from "tslib";
import { CellPresenterBase } from "./CellPresenterBase";
import { SectionHeaderCellModel } from "./SectionHeaderCellModel";
import { markType } from "igniteui-react-core";
import { ContentCellModelHelper } from "./ContentCellModelHelper";
/**
 * @hidden
 */
var SectionHeaderCellPresenter = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(SectionHeaderCellPresenter, _super);
    function SectionHeaderCellPresenter(a) {
        return _super.call(this, a) || this;
    }
    Object.defineProperty(SectionHeaderCellPresenter.prototype, "d", {
        get: function () {
            return this.a;
        },
        enumerable: true,
        configurable: true
    });
    SectionHeaderCellPresenter.prototype.b = function (a) {
        _super.prototype.b.call(this, a);
        var b = a;
        if (a.ar) {
            if (a.aw(SectionHeaderCellModel.kl) || a.aw(SectionHeaderCellModel.kn) || a.aw(SectionHeaderCellModel.km) || a.aw(SectionHeaderCellModel.kp)) {
                if (b.kh == null || (b.kh.length == 0 && b.kv == null)) {
                    if (b.gh == null) {
                        b.ie = "";
                    }
                    else {
                        b.ie = b.gh.toString();
                    }
                }
                else {
                    if (b.kt != null && b.kk == 0) {
                        b.ie = b.kv + "    " + b.kt;
                    }
                    else {
                        b.ie = b.kv;
                    }
                }
                this.d.b4.setRawText(b.ie);
            }
            ContentCellModelHelper.a(this.a.w, b, this.a.z, this.d.b4, this.a);
        }
    };
    SectionHeaderCellPresenter.$t = markType(SectionHeaderCellPresenter, 'SectionHeaderCellPresenter', CellPresenterBase.$);
    return SectionHeaderCellPresenter;
}(CellPresenterBase));
export { SectionHeaderCellPresenter };
//# sourceMappingURL=SectionHeaderCellPresenter.js.map
